import { render, staticRenderFns } from "./LichSuPhanHoiForm.vue?vue&type=template&id=97e61b14"
import script from "./LichSuPhanHoiForm.vue?vue&type=script&lang=js"
export * from "./LichSuPhanHoiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports